export const muziek = [
  "Bohemian Rhapsody",
  "The Beatles",
  "Michael Jackson",
  "Rolling Stones",
  "Beyoncé",
  "Elvis Presley",
  "Bob Dylan",
  "Madonna",
  "Led Zeppelin",
  "Queen",
  "Eminem",
  "Prince",
  "David Bowie",
  "Nirvana",
  "U2",
  "Pink Floyd",
  "Taylor Swift",
  "Coldplay",
  "Justin Bieber",
  "Whitney Houston",
  "Adele",
  "Ed Sheeran",
  "Rihanna",
  "Bruce Springsteen",
  "The Weeknd",
  "The Beach Boys",
  "Stevie Wonder",
  "Johnny Cash",
  "Miles Davis",
  "Kanye West",
  "Jay-Z",
  "Drake",
  "AC/DC",
  "Metallica",
  "Guns N' Roses",
  "Red Hot Chili Peppers",
  "Radiohead",
  "Green Day",
  "Foo Fighters",
  "Pearl Jam",
  "Eagles",
  "ABBA",
  "Bee Gees",
  "Celine Dion",
  "Frank Sinatra",
  "John Lennon",
  "Paul McCartney",
  "George Michael",
  "Elton John",
  "Billy Joel",
  "Prince",
  "Freddie Mercury",
  "Aretha Franklin",
  "Tina Turner",
  "Janis Joplin",
  "Stevie Nicks",
  "Mariah Carey",
  "Beyoncé",
  "Rihanna",
  "Whitney Houston",
  "Alicia Keys",
  "Sia",
  "Bruno Mars",
  "Taylor Swift",
  "Lady Gaga",
  "Katy Perry",
  "Justin Timberlake",
  "Michael Bublé",
  "Sam Smith",
  "Ariana Grande",
  "Billie Eilish",
  "Lana Del Rey",
  "Ed Sheeran",
  "Shawn Mendes",
  "Dua Lipa",
  "The Rolling Stones",
  "Queen",
  "Led Zeppelin",
  "Pink Floyd",
  "The Who",
  "The Doors",
  "Fleetwood Mac",
  "Deep Purple",
  "Guns N' Roses",
  "Nirvana",
  "Red Hot Chili Peppers",
  "Coldplay",
  "Linkin Park",
  "Radiohead",
  "Arctic Monkeys",
  "Green Day",
  "Foo Fighters",
  "U2",
  "Imagine Dragons",
  "Twenty One Pilots",
  "The Beatles",
  "Elvis Presley",
  "Bob Dylan",
  "David Bowie",
  "Prince",
  "Bruce Springsteen",
  "Stevie Wonder",
  "Johnny Cash",
  "Miles Davis",
  "Kanye West",
  "Jay-Z",
  "Drake",
  "Bohemian Rhapsody",
  "Imagine",
  "Hey Jude",
  "Hotel California",
  "Like a Rolling Stone",
  "Stairway to Heaven",
  "Smells Like Teen Spirit",
  "Rolling in the Deep",
  "Sweet Child o' Mine",
  "Wonderwall",
  "Billie Jean",
  "Yesterday",
  "Let It Be",
  "Thriller",
  "Piano Man",
  "Satisfaction",
  "Good Vibrations",
  "Smells Like Teen Spirit",
  "Hey Ya!",
  "Don't Stop Believin'",
  "All Along the Watchtower",
  "I Will Always Love You",
  "Imagine",
  "Hallelujah",
  "Hotel California",
  "Boogie Wonderland",
  "Superstition",
  "I Want to Hold Your Hand",
  "Born to Run",
  "Sweet Home Alabama",
  "Livin' on a Prayer",
  "Like a Prayer",
  "Sweet Caroline",
  "Tears in Heaven",
  "Killing Me Softly",
  "I Will Survive",
  "Wannabe",
  "Waterloo",
  "Purple Rain",
  "Dancing Queen",
  "Dancing in the Dark",
  "Under Pressure",
  "Every Breath You Take",
  "Another Brick in the Wall",
  "Imagine",
  "My Generation",
  "Help!",
  "Let's Stay Together",
  "Unchained Melody",
  "Brown Eyed Girl",
  "Blowin' in the Wind",
  "Heartbreak Hotel",
  "What's Going On",
  "Bridge Over Troubled Water",
  "American Pie",
  "Everyday People",
  "I Heard It Through the Grapevine",
  "A Change Is Gonna Come",
  "Stand By Me",
  "Let's Get It On",
  "Stayin' Alive",
  "Proud Mary",
  "The Times They Are a-Changin'",
  "Free Fallin'",
  "Sweet Child o' Mine",
  "All You Need Is Love",
  "Crazy",
  "Here Comes the Sun",
  "More Than a Feeling",
  "I Want You Back",
  "Summertime",
  "My Girl",
  "With or Without You",
  "You Really Got Me",
  "Yesterday",
  "Mrs. Robinson",
  "I Want to Hold Your Hand",
  "Wonderful Tonight",
  "Baba O'Riley",
  "Sweet Caroline",
  "Hey Ya!",
  "Space Oddity",
  "You Can't Always Get What You Want",
  "Brown Sugar",
  "Let's Twist Again",
  "Maggie May",
  "I Feel Good",
  "Suspicious Minds",
  "Great Balls of Fire",
  "Ain't No Sunshine",
  "Respect",
  "Light My Fire",
  "I Just Called to Say I Love You",
  "Blue Suede Shoes",
  "Layla",
  "Hey Jude",
];
